import { render, staticRenderFns } from "./smartcontracts.vue?vue&type=template&id=a770c85c&scoped=true"
import script from "./smartcontracts.vue?vue&type=script&lang=js"
export * from "./smartcontracts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a770c85c",
  null
  
)

export default component.exports